<template>
  <vbDenVTThuHoiIndex
    :statusByVT="VB_INCOMING_DOC.STATUS_VANTHU.DA_XU_LY"
    @viewDetail="viewDetail"
  ></vbDenVTThuHoiIndex>
</template>
<script>
  import VbDenVtIndex from "./vbDenVTIndex";
  import constants from "../../constants";
  import VbDenVTThuHoiIndex from "./vbDenVTThuHoiIndex";

  export default {
    components: {VbDenVTThuHoiIndex, VbDenVtIndex},
    data() {
      return {
        VB_INCOMING_DOC: constants.VB_INCOMING_DOC
      };
    },
    methods: {
      viewDetail(event) {
        let item = event.doc;
        this.$router.push({
          name: "vbDenThuHoiDetail",
          params: {id: item.id},
          query: this.$route.query
        });
      },
    }
  };
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/vbDenThuHoiIndex.vue